import { pageInfo, trackImport, trackExport, template, getTrackDetail, saveSubmit } from './../api';
import { areaTree, getListCarrier, getListShipType,listShipper } from '../../../../api/index'
import { companyListData } from '../../../mdm/company/api'
const orderTrackMixins = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    importDataObj: null,
    exportResp: null,
    templateResp: null,
    areatreeResp: null,
    trackDetailObj: null,
    saveObj: null,
    carrierObj: null,
    transtypeObj: null,
    shipperObj:null,
    companyObj:null
  },
  mutations: {

    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);//.map(item=> ({...item,projectName: '测试', orderNo:"123456789"}));
    },
    TRACK_IMPORT(state, data) {
      state.importDataObj = data;
    },
    TRACK_EXPORT(state, data) {
      state.exportResp = data;
    },
    TEMPLATE(state, data) {
      state.templateResp = data;
    },
    AREATREE(state, data) {
      state.areatreeResp = data;
    },
    GET_TRACK_DETAIL(state, data) {
      state.trackDetailObj = data;
    },
    SAVE_SUBMIT(state, data) {
      state.saveObj = data;
    },
    CARRIER_LIST(state, data) {
      state.carrierObj = data.obj;
    },
    TRANSTYPE_LIST(state, data) {
      state.transtypeObj = data.obj;
    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    /**
     * 导入
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async trackImport({ commit }, obj) {
      let resp = await trackImport(obj);
      commit('TRACK_IMPORT', resp);
    },
    /**
     * 导出
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async trackExport({ commit }, obj) {
      let resp = await trackExport(obj);
      commit('TRACK_EXPORT', resp);
    },
    /**
     * 模版下载
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async template({ commit }, obj) {
      let resp = await template(obj);
      commit('TEMPLATE', resp);
    },
    /**
     * 省市区下拉框
     */
    async areaTree({ commit }, obj) {
      let resp = await areaTree(obj);
      commit('AREATREE', resp);
    },
    /**
     * 查看详情
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getTrackDetail({ commit }, obj) {
      let resp = await getTrackDetail(obj);
      commit('GET_TRACK_DETAIL', resp);
    },
    /**
     * 保存提交
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async saveSubmit({ commit }, obj) {
      let resp = await saveSubmit(obj);
      commit('SAVE_SUBMIT', resp);
    },
    /**
     * 承运商
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async carrierList({ commit }, obj) {
      let resp = await getListCarrier(obj);
      commit('CARRIER_LIST', resp);
    },
    /**
     * 运输方式
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async transTypeList({ commit }, obj) {
      let resp = await getListShipType(obj);
      commit('TRANSTYPE_LIST', resp);
    },

    /*主数据-货主*/
    async listShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },

    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
  }
}
export default orderTrackMixins



// WEBPACK FOOTER //
// ./src/page/transit/orderTrack/store/orderTrack.store.js